import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CustomCursor } from './Components/CustomCursor/CustomCursor';
import LogoPage from './LogoPage/LogoPage';
import CraterGrid from './Pages/CraterGridPages/CraterGrid';
import PotatoGrid from './Pages/PotatoPages/PotatoGrid';
import CloudDownPage from './Pages/CloudDownPage/CloudDownPage';
import Part3Gallery from './Pages/Part3Gallery/Part3Gallery';
import { useDataLoader } from './hooks/useDataLoader';

// 加载消息组件
const LoadingMessage = ({ children }) => (
  <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
    <div className="bg-black/70 text-white/90 px-4 py-2 rounded-lg backdrop-blur-sm">
      {children}
    </div>
  </div>
);

const App = () => {
  // 使用数据加载钩子
  const {
    isLoading,
    loadingStatus,
    loadError,
    craterData,
    potatoData,
    appReady
  } = useDataLoader();

  // 状态
  const [isDarkMode, setIsDarkMode] = React.useState(false);
  const [showLines, setShowLines] = React.useState(true);
  const [selectedCrater, setSelectedCrater] = React.useState(null);

  // 显示加载状态
  if (isLoading) {
    return <LoadingMessage>{loadingStatus}</LoadingMessage>;
  }

  // 显示错误状态
  if (loadError) {
    return <LoadingMessage>数据加载失败: {loadError.message}</LoadingMessage>;
  }

  return (
    <Router>
      <CustomCursor />
      <Routes>
        <Route 
          path="/" 
          element={
            <>
              <CloudDownPage 
                isDarkMode={isDarkMode}
                setIsDarkMode={setIsDarkMode}
                showLines={showLines}
                setShowLines={setShowLines}
                selectedCrater={selectedCrater}
                setSelectedCrater={setSelectedCrater}
                craterData={craterData?.preview || []}
                potatoData={potatoData}
                appReady={appReady} 
              />
              {/* Floating Footer */}
              <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50">
                <div className={`px-4 py-2 text-sm ${isDarkMode ? 'text-white' : 'text-black'}`}>
                  Made in{' '}
                  <a 
                    href="https://mc.tencent.com/HRVjVcS5" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="font-bold"
                  >
                    CodeBuddy
                  </a>
                  {' | Powered by '}
                  <a 
                    href="https://docs.cloudbase.net/ai/cloudbase-ai-toolkit/?from=csdn-hackathon-2025" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="font-bold"
                  >
                    CloudBase
                  </a>
                </div>
              </div>
            </>
          } 
        />
        <Route 
          path="/grid" 
          element={
            <CraterGrid craters={craterData?.full || []} isDarkMode={isDarkMode} />
          }
        />
        <Route 
          path="/potato" 
          element={<PotatoGrid potatoes={potatoData} isDarkMode={isDarkMode} />}
        />
        <Route 
          path="/logo" 
          element={<LogoPage />}
        />
        <Route 
          path="/gallery" 
          element={<Part3Gallery />}
        />
      </Routes>
    </Router>
  );
};

export default App;